import { DOWNLOAD_VOUCHERS, DOWNLOAD_VOUCHERS_SUCCESS, DOWNLOAD_VOUCHERS_ERROR, DOWNLOAD_VOUCHERS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetDownloadVouchers = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_VOUCHERS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_VOUCHERS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_VOUCHERS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_VOUCHERS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetDownloadVouchers;
